import React, { Fragment, useState, useEffect } from "react";
import { EmitterType, RuleJsonType } from "hello-mono-sdk/packages/core";
import { MenuItem } from "../../types/frontend";
import "./MenuBar.scss";
import icon from "../../assets/images/icon.svg";
import iconWhite from "../../assets/images/icon-white.svg";

interface IProps {
  menuItems: MenuItem[];
  runRule: (rule: RuleJsonType) => void;
  isRuleRunning: boolean;
  specMode: string;
  emitter: EmitterType;
}

const MenuBar: React.FC<IProps> = ({
  menuItems,
  runRule,
  isRuleRunning,
  specMode,
  emitter,
}) => {
  const [selectedSubMenu, setSelectedSubMenu] = useState<string | null>(null);
  const [menuItemIsActive, setMenuItemIsActive] = useState<{
    [key: string]: boolean;
  }>(
    menuItems.reduce((acc: { [key: string]: boolean }, item: MenuItem) => {
      let activeState = item?.rule?.isActive ?? false;
      let ruleId = item?.rule?.id;

      if (typeof ruleId === "string") {
        acc[ruleId] = activeState;
      }

      return acc;
    }, {})
  );
  useEffect(() => {
    let handleRuleActivated = ({ ruleId }: { ruleId: string }) => {
      setMenuItemIsActive((prevState: { [key: string]: boolean }) => {
        let newState = { ...prevState, [ruleId]: true };
        return newState;
      });
    };

    let handleRuleDeactivated = ({ ruleId }: { ruleId: string }) => {
      setMenuItemIsActive((prevState: { [key: string]: boolean }) => {
        let newState = { ...prevState, [ruleId]: false };
        return newState;
      });
    };

    emitter.on("RULE_ACTIVATED", handleRuleActivated);

    emitter.on("RULE_DEACTIVATED", handleRuleDeactivated);

    return () => {
      emitter.off("RULE_ACTIVATED", handleRuleActivated);
      emitter.off("RULE_DEACTIVATED", handleRuleDeactivated);
    };
  }, [emitter]);

  return (
    <div className={`menu-container ${specMode === "SPEC" ? "spec-mode" : ""}`}>
      <div
        className="menu"
        style={{
          overflowY: menuItems?.length > 5 ? "scroll" : "hidden",
        }}
      >
        {menuItems.map(
          (item) =>
            item.rule?.id &&
            menuItemIsActive[item.rule.id] && (
              <Fragment key={item.id}>
                <button
                  className="feature-button-menu"
                  style={{
                    backgroundColor:
                      selectedSubMenu === item.text ? "#505050" : "",
                    justifyContent: "center",
                  }}
                  onClick={(e) => {
                    e.currentTarget.style.backgroundColor =
                      selectedSubMenu === item.text ? "#505050" : "#fff";
                    e.currentTarget.style.color = "#000";

                    if (isRuleRunning) {
                      alert("Another interaction already running");
                      return;
                    }
                    if (item.children && item.children.length > 0) {
                      setSelectedSubMenu((prev) =>
                        prev === item.text ? null : item.text
                      );
                    } else {
                      setSelectedSubMenu(null);
                      if (item.rule) {
                        runRule(item.rule);
                      }
                    }
                  }}
                  onMouseOver={(e) => {
                    (e.currentTarget.style.cursor = "pointer"),
                      (e.currentTarget.style.backgroundColor =
                        "rgba(163, 160, 160, 0.53)");
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor =
                      selectedSubMenu === item.text ? "#505050" : "#fff";
                    e.currentTarget.style.color = "#000";
                  }}
                  onTouchStart={(e) => {
                    e.currentTarget.style.backgroundColor =
                      "rgba(163, 160, 160, 0.53)";
                  }}
                  onTouchEnd={(e) => {
                    e.currentTarget.style.backgroundColor =
                      selectedSubMenu === item.text ? "#505050" : "#fff";
                    e.currentTarget.style.color = "#000";
                  }}
                  data-id={item.id}
                >
                  {/* <img className="feature-icon" src={selectedSubMenu === item.text ? iconWhite : icon} alt="icon" /> */}
                  <div
                    className="feature-title"
                    style={{
                      color: selectedSubMenu === item.text ? "#fff" : "#000",
                      textAlign: "center",
                    }}
                  >
                    {item.text}
                  </div>
                </button>

                {selectedSubMenu === item.text &&
                  item.children &&
                  item.children.length > 0 && (
                    <div className="sub-menu">
                      {item.children.map((subItem) => (
                        <Fragment key={subItem.id}>
                          <button
                            className="feature-button"
                            onClick={(e) => {
                              e.currentTarget.style.opacity = "1";
                              if (isRuleRunning) {
                                alert("Another interaction already running");
                                return;
                              }
                              if (subItem.rule) {
                                runRule(subItem.rule);
                              }
                            }}
                            style={{
                              justifyContent: "center",
                            }}
                            onMouseOver={(e) => {
                              (e.currentTarget.style.cursor = "pointer"),
                                (e.currentTarget.style.opacity = "0.8");
                            }}
                            onMouseOut={(e) => {
                              e.currentTarget.style.opacity = "1";
                            }}
                            onTouchStart={(e) => {
                              e.currentTarget.style.opacity = "0.8";
                            }}
                            onTouchEnd={(e) => {
                              e.currentTarget.style.opacity = "1";
                            }}
                          >
                            {/* <img className="feature-icon" src={iconWhite} alt="icon" /> */}
                            <div className="feature-title">{subItem.text}</div>
                          </button>{" "}
                        </Fragment>
                      ))}
                    </div>
                  )}
              </Fragment>
            )
        )}
      </div>
    </div>
  );
};

export default MenuBar;
